// extracted by mini-css-extract-plugin
export var active = "_1o-9";
export var backButton = "_1o-8";
export var clone = "_1o-e";
export var collapseBar = "_1o-k";
export var collapseMode = "_1o-m";
export var collapsed = "_1o-o";
export var dimmed = "_1o-i";
export var dragHandle = "_1o-c";
export var dropdownIcon = "_1o-g";
export var expanding = "_1o-n";
export var hidden = "_1o-x";
export var iconContainer = "_1o-q";
export var iconSwapper = "_1o-w";
export var navItem = "_1o-6";
export var navItemIcon = "_1o-f";
export var navProfile = "_1o-7";
export var notificationCountBadge = "_1o-j";
export var notificationDot = "_1o-r";
export var optionsContainer = "_1o-h";
export var primaryNav = "_1o-0";
export var primaryNavDivider = "_1o-v";
export var primaryNavResizeHandle = "_1o-2";
export var primaryNavResizing = "_1o-1";
export var primaryNavTabSection = "_1o-u";
export var primaryTab = "_1o-p";
export var primaryTabIconBox = "_1o-s";
export var secondaryNav = "_1o-3";
export var selected = "_1o-t";
export var settingsNav = "_1o-4";
export var settingsNavItems = "_1o-5";
export var show = "_1o-d";
export var sideNav = "_1o-l";
export var teamItem = "_1o-a";
export var userProfileItem = "_1o-b";